import SearchResults from './SearchResults';

export default function SearchShortNotes() {
  return <SearchResults categoryId={4} />;
}
